import React from 'react';

import PercentageProgressListItem from '/component/base/PercentageProgressListItem';

interface ProgressBarContentProps {
  isComplete: boolean;
  data: {
    current: number;
    target: number;
  };
  titleProps: {
    getTitle: () => string;
  };
}

const ProgressBarContent: React.FC<ProgressBarContentProps> = ({
  isComplete = false,
  data = {current: 0, target: 0},
  titleProps = {getTitle: () => ''},
}) => {
  const isMaxTarget = Math.floor(data.current) > Math.floor(data.target);

  return (
    <PercentageProgressListItem
      denominator={parseInt(String(data.target), 10)}
      hasCheckbox
      isChecked={isComplete}
      label={titleProps.getTitle()}
      numerator={
        isMaxTarget
          ? parseInt(String(data.target), 10)
          : parseInt(String(data.current), 10)
      }
      readonly
      oneLineLayout
    />
  );
};

export default ProgressBarContent;
